<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <el-row class="flex">
      <el-input
        size="small"
        v-model="searchFrom.metaDataCode"
        class="w-200px mr-10px"
        placeholder="元数据代码"
        clearable
      ></el-input>
      <el-input
        size="small"
        v-model="searchFrom.metaDataName"
        class="w-200px mr-10px"
        placeholder="元数据名称"
        clearable
      ></el-input>
      <el-input
        size="small"
        v-model="searchFrom.dataType"
        class="w-200px mr-10px"
        placeholder="数据类型"
        clearable
      ></el-input>
      <el-select
        size="small"
        v-model="searchFrom.dataSourceTypeName"
        class="w-200px mr-10px"
        placeholder="来源数据库类型"
        clearable
      >
        <el-option
          v-for="(item, index) in dataTypeList"
          :key="index"
          :value="item.item1"
          :label="item.item2"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        v-model="searchFrom.dataSourceBase"
        class="w-200px mr-10px"
        placeholder="来源数据库名称"
        clearable
      ></el-input>
      <el-input
        size="small"
        v-model="searchFrom.tableName"
        class="w-200px mr-10px"
        placeholder="来源实体名称"
        clearable
      ></el-input>
      <el-date-picker
        type="date"
        size="small"
        v-model="searchFrom.startDate"
        class="w-200px mr-10px"
        placeholder="开始日期"
        clearable
        value-format="yyyy-MM-dd HH:mm:ss"
      ></el-date-picker>
      <el-date-picker
        type="date"
        size="small"
        v-model="searchFrom.endDate"
        class="w-200px mr-10px"
        placeholder="结束日期"
        clearable
        value-format="yyyy-MM-dd HH:mm:ss"
      ></el-date-picker>
    </el-row>
    <el-row class="mt-10px flex">
      <el-button type="primary" size="small" @click="sizeChange">搜索</el-button>
      <el-button size="small" @click="resetSearchQuery">重置</el-button>
      <el-button
        size="small"
        :loading="exportLoading"
        @click="exportMetaList"
        :disabled="!$hasAccess('export')"
        >导出</el-button
      >
    </el-row>
    <el-table
      :data="tableList"
      height="calc(100% - 152px)"
      border
      class="mt-20px"
      v-loading="tableLoading"
      :row-key="(record) => record.id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column
        prop="metaDataCode"
        label="元数据代码"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="metaDataName"
        label="元数据名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="dataType" label="数据类型" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="dataSourceTypeName"
        label="来源数据库类型"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="dataSourceBase"
        label="来源数据库名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="tableName"
        label="来源实体名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="100">
        <template #default="{ row }">
          <el-button :disabled="!$hasAccess('read')" @click.stop="viewDetail(row)" size="mini">{{
            $t('view')
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tr">
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.recordCount"
      ></el-pagination>
    </div>
    <viewMetadata
      v-if="isShowViewDialog"
      :visible.sync="isShowViewDialog"
      :operateMetadata="operateMetadata"
    ></viewMetadata>
  </el-card>
</template>

<script>
import MetadataManageService from '@/services/MetadataManageService'
import MetadataListService from '@/services/metadataListService'
import fnMixin from '@/assets/js/fnMixins'

const viewMetadata = () => {
  return import('./components/viewMetadata')
}

export default {
  name: 'metadataList',
  components: {
    viewMetadata,
  },
  data() {
    return {
      searchFrom: {
        metaDataCode: '', // 元数据代码
        metaDataName: '', // 元数据名称
        dataType: '', // 数据类型
        dataSourceTypeName: '', // 来源数据库类型
        dataSourceBase: '', // 来源数据库名称
        tableName: '', // 来源实体名称
        startDate: '', // 开始日期
        endDate: '', // 结束日期
      },
      dataTypeList: [], // 类型下拉框
      tableList: [], // 列表数据
      tableLoading: '', // 列表loading
      selectedList: [], // 列表选中项
      page: {
        pageNo: 1,
        pageSize: 15,
        recordCount: 0,
      }, // 分页数据
      isShowViewDialog: false, // 是否显示查看弹窗
      exportLoading: false, // 导出按钮loading
      operateMetadata: null, //
    }
  },
  methods: {
    // 获取类型下拉框数据
    async getDbTypes() {
      const res = await MetadataManageService.getDbTypes()
      if (res && res.code === 0) {
        this.dataTypeList = res.data
      }
    },
    /**
     * @description 搜索
     */
    async getTableDataList() {
      this.tableLoading = true
      const payload = {
        meta_data_code: {
          $text: this.searchFrom.metaDataCode,
        },
        meta_data_name: {
          $text: this.searchFrom.metaDataName,
        },
        data_type: {
          $text: this.searchFrom.dataType,
        },
        data_source_type: this.searchFrom.dataSourceTypeName,
        data_source_base: {
          $text: this.searchFrom.dataSourceBase,
        },
        table_name: {
          $text: this.searchFrom.tableName,
        },
        pageno: this.page.pageNo,
        pageSize: this.page.pageSize,
      }
      payload['created_time[$gt]'] = this.searchFrom.startDate
      payload['created_time[$lt]'] = this.searchFrom.endDate
      const res = await MetadataListService.list(payload)
      this.tableLoading = false
      if (res && res.data && res.code === 0) {
        this.tableList = res.data
        this.page.recordCount = res.page.recordCount
      }
    },

    /**
     * @description 重置
     */
    resetSearchQuery() {
      this.searchFrom = {
        metaDataCode: '',
        metaDataName: '',
        dataType: '',
        dataSourceTypeName: '',
        dataSourceBase: '',
        tableName: '',
        startDate: '',
        endDate: '',
      }
      this.sizeChange()
    },

    /**
     * @description 导出
     */
    async exportMetaList() {
      this.exportLoading = true
      const res = await MetadataListService.exportMetadataList({
        urlParam: `meta_data_code[$text]=${this.searchFrom.metaDataCode}&meta_data_name[$text]=${this.searchFrom.metaDataName}&data_source_type=${this.searchFrom.dataType}&created_time[$gt]=${this.searchFrom.startDate}&created_time[$lt]=${this.searchFrom.endDate}`,
        downloadType: 0, // 0: url, 1: 文件流
        ids: _.map(this.selectedList, 'id'),
      })
      this.exportLoading = false
      if (res) {
        const time = fnMixin.methods.getNowTime()
        fnMixin.methods.downLoadExcel(`元数据清单${time}`, res)
      }
    },

    /**
     * @description 查看
     * @param {Object} metadataItem 操作项数据
     */
    viewDetail(metadataItem) {
      this.operateMetadata = { ...metadataItem }
      this.isShowViewDialog = true
    },

    /**
     * @description 跨页多选
     * @param {Array} selectedList
     */
    handleSelectionChange(selectedList) {
      this.selectedList = selectedList
    },

    sizeChange() {
      this.page.pageNo = 1
      this.getTableDataList()
    },

    currentChange() {
      this.getTableDataList()
    },
  },

  async created() {
    await this.getDbTypes()
    this.getTableDataList()
  },
}
</script>
